import { Component } from "react";
import request from "../../../../request";
import { errorToast } from "../../../../toast";
import { CircularProgress, IconButton } from "@mui/material";
import { delay } from "../../../../utils";
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';
import swal from 'sweetalert';
import { v4 as uuid } from 'uuid';


export default class Setting extends Component {

   id = `txt-setting-${uuid()}`;

	state = {
		editing: false,
      loading: false,
		value: ''
	}

	getSettingName() {
		return this.props.settingName;
	}

	getCurrentValue() {
		return this.props.value;
	}

	submit = async () => {

		const txtSetting = document.getElementById(this.id);
		const { value } = this.state;

		if (!value) {
			errorToast("Setting can't be empty");
			return txtSetting.focus();
		}

		try {

         this.setState({ loading: true });

			const settingName = this.getSettingName();
			const data = { [settingName]: value };
			await request.patch('/api/admin/system-settings', data);

			await this.props.onChange(value);
			await this.updateState({ editing: false });

		} catch (err) {
			swal("Error", err.message, 'error');
		} finally {
			this.setState({ loading: false });
		}
	}

	render() {

		const { editing, loading } = this.state;

		let actions;

      if (loading) { 
         actions = <div className="flex items-center h-full px-4">
            <CircularProgress size={16} thickness={6} />
         </div>
      } else if (editing) {
			actions = <>
				<IconButton size='small' color='primary' onClick={this.submit}>
					<DoneIcon />
				</IconButton>
				<IconButton size='small' color='error' onClick={() => this.updateState({ editing: false })}>
					<CloseIcon />
				</IconButton>
			</>
		} else {
			actions = <IconButton
				onClick={
					async () => {
						const editing = true;
						const value = this.getCurrentValue();
						this.updateState({ value, editing });
						await delay(100);

						const elem = document.getElementById(this.id)
						elem.focus();
						
					}
				}
            disabled={this.props.disabled}
			>
				<EditIcon />
			</IconButton>
		}

		return <div>
			<div className='text-sm text-gray-500 font-semibold'>
				{this.props.label}
			</div>
			<div className='bg-gray-200 rounded grid grid-cols-[1fr,auto]'>
				<div className='h-full flex items-center'>
					<input
						className='px-2 w-full outline-none bg-transparent h-[40px]' 
						id={this.id}
						onChange={ (e) => this.updateState({ value: e.target.value })}
						value={editing ? this.state.value : this.getCurrentValue()}
						disabled={!editing || loading || this.props.disabled}
					/>
				</div>
				<div className='h-full flex items-center'>
					{actions}
				</div>
			</div>
		</div>
	}
}